import UserState from 'redux/user/interfaces/userState';

const INIT_USER_STATE: UserState = {
  loading: false,
  error: null,
  data: null,
};

export default INIT_USER_STATE;
